import { Plus, X } from "lucide-react";

export function UserMealFormMealType({
  form,
  setShowMealTypeDropdown,
  showMealTypeDropdown,
  availableTags,
  addTag,
  removeTag,
}) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <label className="block text-sm font-medium text-gray-900 mb-2">
        Meal Tags
      </label>

      {/* Selected Tags */}
      {form.mealTagList.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {form.mealTagList.map((tag) => (
            <div
              key={tag.tagId}
              className="inline-flex items-center gap-2 px-3 py-1.5 bg-gray-900 text-white rounded-full text-sm font-medium"
            >
              <span>{tag.tagContent || "Unknown tag"}</span>
              <button
                type="button"
                onClick={() => removeTag(tag.tagId)}
                className="hover:bg-gray-700 rounded-full p-0.5 transition-colors"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add Tag Dropdown */}
      <div className="relative">
        <button
          type="button"
          onClick={() => setShowMealTypeDropdown(!showMealTypeDropdown)}
          className="px-4 py-2 border border-gray-200 rounded-lg text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Add Tag
        </button>

        {showMealTypeDropdown && (
          <div className="absolute top-full left-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
            {availableTags.length > 0 ? (
              availableTags.map((tag) => (
                <button
                  key={tag.tagId}
                  type="button"
                  onClick={() => addTag(tag)}
                  className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors first:rounded-t-lg last:rounded-b-lg"
                >
                  {tag.tagContent}
                </button>
              ))
            ) : (
              <p className="px-4 py-3 text-sm text-gray-500">
                No more tags to add. Create new ones from Settings.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
